import React from 'react';

import { IconPropTypes } from 'ggApp/types/propTypes';

const FacebookMessanger = ({ color, size, className }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.47983 17.3898L6.47429 17.3848C4.95257 16.0236 4 14.0465 4 11.7003C4 7.30281 7.39802 4 12.0001 4C16.6022 4 20.0003 7.30281 20.0003 11.7003C20.0003 16.0978 16.6022 19.4007 12.0001 19.4007C11.1632 19.4007 10.3705 19.2909 9.63672 19.0884L9.63095 19.0868C8.84393 18.8722 8.12761 19.0664 7.40959 19.3832L7.40916 19.3715C7.38046 18.5894 7.02789 17.8837 6.47983 17.3898ZM5.46483 21.2236C5.48294 21.791 6.06846 22.1592 6.58758 21.9318C7.23884 21.6445 8.35524 20.8119 9.10472 21.0163C10.0162 21.2679 10.988 21.4007 12.0001 21.4007C17.634 21.4007 22.0003 17.2738 22.0003 11.7003C22.0003 6.12681 17.634 2 12.0001 2C6.36625 2 2 6.12681 2 11.7003C2 14.6159 3.19519 17.135 5.14089 18.8755C5.68462 19.3655 5.44513 20.5784 5.46483 21.2236ZM16.8944 10.4472C17.1414 9.95324 16.9412 9.35256 16.4472 9.10557C15.9532 8.85858 15.3526 9.05881 15.1056 9.55279L13.726 12.3118L10.7071 9.29289C10.4798 9.0656 10.1571 8.96142 9.83982 9.01291C9.52252 9.0644 9.24933 9.26528 9.10557 9.55279L7.10557 13.5528C6.85858 14.0468 7.05881 14.6474 7.55279 14.8944C8.04676 15.1414 8.64744 14.9412 8.89443 14.4472L10.274 11.6882L13.2929 14.7071C13.5202 14.9344 13.8429 15.0386 14.1602 14.9871C14.4775 14.9356 14.7507 14.7347 14.8944 14.4472L16.8944 10.4472Z"
            fill={color}
        />
    </svg>
);

FacebookMessanger.propTypes = {
    ...IconPropTypes,
};

FacebookMessanger.defaultProps = {
    color: '#333333',
    size: '24px',
};

export default FacebookMessanger;
